import request from '@/utils/request'

export default {
  getList(param) {
    return request({
      url: `rebuild/tasks/page`,
      method: 'get',
      params: param
    })
  },
  addTask(param) {
    return request({
      url: `rebuild/tasks`,
      method: 'post',
      params: param
    })
  },
  getDetail(param) {
    return request({
      url: `rebuild/tasks/`+param.tid,
      method: 'get',
      params: param
    })
  },
  deleteTask(param) {
    return request({
      url: `rebuild/tasks/` + param.tid,
      method: 'delete',
      params: param
    })
  },
  startRebuild(param) {
    return request({
      url: `rebuild/tasks/`+param.tid+`/commit`,
      method: 'put',
      params: param
    })
  },
  beforeStartRebuild(param) {
    return request({
      url: `rebuild/tasks/`+param.tid+`/start`,
      method: 'put',
      params: param
    })
  },
  getAreaList(param) {
    return request({
      url: `rebuild/tasks/`+param.tid+`/data`,
      method: 'get',
      params: param
    })
  },
  getPointList(param) {
    return request({
      url: `rebuild/tasks/`+param.tid+`/control`,
      method: 'get',
      params: param
    })
  },
  getImgList(param) {
    return request({
      url: `rebuild/tasks/control/`+param.cid+`/photo`,
      method: 'get',
      params: param
    })
  },
  deleteImg(param) {
    return request({
      url: `rebuild/tasks/control/photo/`+param.pid,
      method: 'delete',
      params: param
    })
  },
  addPoint(param) {
    return request({
      url: `rebuild/tasks/`+param.tid+`/control`,
      method: 'post',
      params: param
    })
  },
  editPoint(param) {
    return request({
      url: `rebuild/tasks/control/`+param.cid,
      method: 'put',
      params: param
    })
  },
  deletePoint(param) {
    return request({
      url: `rebuild/tasks/control/`+param.cid,
      method: 'delete',
      params: param
    })
  },
  addCollections(param) {
    return request({
      url: `rebuild/data/collections`,
      method: 'post',
      params: param
    })
  },
  addPhotoGroup(param) {
    return request({
      url: `rebuild/data/photoGroups`,
      method: 'post',
      params: param
    })
  },
  deleteCollection(param) {
    return request({
      url: `rebuild/data/collections/`+param.cid,
      method: 'delete',
      params: param
    })
  },
  getCollection(param) {
    return request({
      url: `rebuild/data/collections/`+param.cid,
      method: 'get',
      params: param
    })
  },
  editPositionSys(param) {
    return request({
      url: `rebuild/tasks/`+param.tid+`/control/coordinateSys`,
      method: 'put',
      params: param
    })
  },
  taskCount(param) {
    return request({
      url: `rebuild/tasks/status`,
      method: 'get',
      params: param
    })
  },
  cancelRebuild(param) {
    return request({
      url: `rebuild/tasks/`+param.tid+`/stop`,
      method: 'put',
      params: param
    })
  },
  photoCapacity(param) {
    return request({
      url: `rebuild/photoCapacity/user`,
      method: 'get',
      params: param
    })
  },
  addImgTemp(param) {
    return request({
      url: `rebuild/data/photoGroups/`+param.gid+`/tempData`,
      method: 'post',
      params: param
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/task.js